import type { Authentication } from '@/generic/authentication/domain/Authentication.ts';
import { Optional } from '@/generic/functional';
import { Token } from '@/generic/authentication/domain/Token.ts';
import { RequestedPage } from '@/generic/authentication/domain/RequestedPage.ts';

const ERROR = 'error';
const STATE = 'state';
const FAKE_TOKEN = 'fake-token';

export class AuthenticationFakeApi implements Authentication {
  async login(): Promise<void> {
    return;
  }

  async loginAgain(): Promise<void> {
    return;
  }

  async logout(): Promise<void> {
    return;
  }

  async loggedIn(): Promise<RequestedPage> {
    const parameters = new URLSearchParams(globalThis.location.search);

    if (parameters.has(ERROR)) {
      throw new Error(parameters.get(ERROR) ?? ERROR);
    }

    return RequestedPage.fromPath(parameters.get(STATE));
  }

  async getToken(): Promise<Optional<Token>> {
    return Optional.of(new Token(FAKE_TOKEN));
  }
}
